import { useCallback, useMemo } from 'react';
import {
  businessWifiOption,
  fibreInternetOption,
  fieldAddProductVulcan,
  fieldOrderIdTSB,
  fieldBusinessConnect,
  fieldServiceAddress,
  fieldSigningAuthorityVulcan,
  fieldUnitNumber,
  fieldUnitType,
  prequalificationField,
  resetFieldOfVulcan,
  secureBusinessPlanVulcan,
  Prequalification
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

const CustomerHelpers = ({ fieldName, formFields, setResetSection }) => {
  let isProductDisable;

  const addProductVulcanValue = getFieldValue(
    fieldAddProductVulcan,
    formFields
  );
  const valueofTSBId = getFieldValue(fieldOrderIdTSB, formFields);

  const existingVulcanProduct = getFieldValue('productVulcan', formFields);

  if (
    fieldName === fieldSigningAuthorityVulcan ||
    fieldName === fieldServiceAddress
  ) {
    if (addProductVulcanValue.includes(fieldBusinessConnect) || valueofTSBId) {
      resetFieldOfVulcan.forEach(value => {
        formFields[value].isRequired = false;
        formFields[value].value = '';
      });
      formFields[fieldUnitNumber].value = '';
      formFields[fieldUnitType].value = '';
      return true;
    } else {
      resetFieldOfVulcan.forEach(value => {
        formFields[value].isRequired = true;
      });
    }
  }

  if (fieldName === fieldAddProductVulcan) {
    if (!formFields[fieldAddProductVulcan].value) {
      formFields[fieldAddProductVulcan].value = [
        fibreInternetOption,
        businessWifiOption
      ];
      setResetSection(true);
    }

    if (existingVulcanProduct) {
      isProductDisable = existingVulcanProduct.includes(
        'Business Wifi Existing'
      );
    }
    if (isProductDisable) {
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [fibreInternetOption],
        true
      );
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [businessWifiOption],
        false
      );
    } else {
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [fibreInternetOption, businessWifiOption],
        true
      );
    }
    // Reset the prequalification form fields
    if (
      addProductVulcanValue &&
      !addProductVulcanValue.includes('Telus Secure Business')
    ) {
      prequalificationField.map(fieldName => {
        formFields[fieldName].value = undefined;
      });
      formFields['isHomeBased'].value = undefined;
    }
  }
  if (valueofTSBId && fieldName === 'secureBusinessProductVulcan') {
    formFields[secureBusinessPlanVulcan].isRequired = false;
    formFields[secureBusinessPlanVulcan].value = '';
    formFields.smokeDetectorWarningNoteVulcan.isVisible = false;
    return true;
  }
  if (valueofTSBId) {
    if (fieldName === 'prequalification') {
      // eslint-disable-next-line no-lone-blocks
      prequalificationField.map(fieldName => {
        formFields[fieldName].isRequired = false;
      });
      formFields['isHomeBased'].isRequired = false;

      return true;
    }
  }
};

export default CustomerHelpers;
